import Categories from 'ContentUtils/js/constants/Categories';

// Content model helper functions
export const contentIsPublished = content => {
  return content.get('isPublished');
};
export const getCategory = (category, subcategory) => {
  return typeof subcategory === 'string' && subcategory.toLowerCase() === 'site_page' ? Categories['site-page'] : Categories[category];
};